import {
  API_CURRENT_PRODUCT_PROGRAM,
  API_LOAN_INVESTOR_INFO,
  API_LOAN_PROGRAM_DETAILS,
  API_LOCK_EXTENSION_COST,
} from 'config'
import Api from 'services/api'

export const getCurrentProductTypesPrograms = () => {
  return Api.get(API_CURRENT_PRODUCT_PROGRAM)
}

export const getLockExtensionCost = () => {
  return Api.get(API_LOCK_EXTENSION_COST)
}

export const getInvestorInfo = (ratesheetID: number, programID: number) => {
  return Api.get(API_LOAN_INVESTOR_INFO, {}, { ratesheetID, programID })
}

export const getLoanProgramDetails = (
  ratesheetID: number,
  productID: number,
  programID: number,
  subProgramID?: number,
) => {
  return Api.get(API_LOAN_PROGRAM_DETAILS, {}, { ratesheetID, productID, programID, subProgramID })
}
